import React from 'react';
import { Button } from '../ui/Button';
interface FinalCTAProps {
  onNavigate: (page: string) => void;
}
export function FinalCTA({
  onNavigate
}: FinalCTAProps) {
  return <section className="py-24 relative overflow-hidden" data-id="element-137">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0f] to-[#0f172a]" data-id="element-138" />
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1493238792015-1a419ae4ce68?auto=format&fit=crop&q=80')] bg-cover bg-center opacity-10 mix-blend-overlay" data-id="element-139" />

      <div className="container mx-auto px-4 md:px-6 relative z-10 text-center" data-id="element-140">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-141">
          Bereit für die <span className="text-cyan-400" data-id="element-142">digitale Zukunft</span>
          ?
        </h2>
        <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-143">
          Lassen Sie uns gemeinsam prüfen, wie Digital Key Ihre Prozesse
          vereinfacht – von Privatkunden bis zur Großflotte.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-144">
          <Button variant="primary" size="lg" className="w-full sm:w-auto min-w-[200px]" onClick={() => onNavigate('contact')} data-id="element-145">
            Demo anfragen
          </Button>
          <Button variant="secondary" size="lg" className="w-full sm:w-auto min-w-[200px]" onClick={() => onNavigate('contact')} data-id="element-146">
            Kontakt aufnehmen
          </Button>
        </div>
      </div>
    </section>;
}